export default "__VITE_ASSET__c2a9bbd8__"